/**
 * Progressive enhancement for native horizontal rails.
 * Basic scrolling works without JS (overflow-x + scroll-snap).
 * Mouse drag only engages after a small threshold so poster links still click.
 */
(function () {
  var DRAG_THRESHOLD = 8;

  function initRail(root) {
    if (!root || root.dataset.geRailReady === '1') return;
    var scroller = root.querySelector('[data-rail-scroller]');
    if (!scroller) return;
    root.dataset.geRailReady = '1';

    var prev = root.querySelector('[data-rail-prev]');
    var next = root.querySelector('[data-rail-next]');

    function updateButtons() {
      if (!prev || !next) return;
      var max = scroller.scrollWidth - scroller.clientWidth - 1;
      prev.disabled = scroller.scrollLeft <= 1;
      next.disabled = scroller.scrollLeft >= max;
    }

    function scrollByDir(dir) {
      var amount = Math.max(scroller.clientWidth * 0.8, 240);
      scroller.scrollBy({ left: dir * amount, behavior: 'smooth' });
    }

    if (prev) prev.addEventListener('click', function () { scrollByDir(-1); });
    if (next) next.addEventListener('click', function () { scrollByDir(1); });
    scroller.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();

    // Optional mouse drag on fine pointers — threshold so clicks still work
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      var pointerId = null;
      var startX = 0;
      var startScroll = 0;
      var dragging = false;
      var moved = false;

      scroller.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse' || e.button !== 0) return;
        if (e.target.closest('button, [data-rail-prev], [data-rail-next]')) return;
        pointerId = e.pointerId;
        startX = e.clientX;
        startScroll = scroller.scrollLeft;
        dragging = false;
        moved = false;
      });

      scroller.addEventListener('pointermove', function (e) {
        if (pointerId !== e.pointerId) return;
        var dx = e.clientX - startX;
        if (!dragging && Math.abs(dx) >= DRAG_THRESHOLD) {
          dragging = true;
          moved = true;
          root.classList.add('is-dragging');
          try { scroller.setPointerCapture(e.pointerId); } catch (_) {}
        }
        if (!dragging) return;
        scroller.scrollLeft = startScroll - dx;
      });

      function endDrag(e) {
        if (pointerId !== e.pointerId) return;
        if (dragging) {
          root.classList.remove('is-dragging');
          try { scroller.releasePointerCapture(e.pointerId); } catch (_) {}
        }
        pointerId = null;
        dragging = false;
      }

      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);

      // Suppress click only when the gesture was a drag
      scroller.addEventListener('click', function (e) {
        if (!moved) return;
        moved = false;
        e.preventDefault();
        e.stopPropagation();
      }, true);
    }
  }

  function boot() {
    document.querySelectorAll('[data-ge-rail]').forEach(initRail);
  }

  document.addEventListener('ge:rail-refresh', function (e) {
    var root = e.target && e.target.closest
      ? e.target.closest('[data-ge-rail]') || e.target
      : null;
    if (root && root.hasAttribute && root.hasAttribute('data-ge-rail')) {
      root.dataset.geRailReady = '';
      initRail(root);
      return;
    }
    boot();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
